export { IllustrationQuestion } from './IllustrationQuestion';
